import { useComponentLabels } from '@hooks';
import i18n from '@components/i18n/i18n';

export default function (name, baseLabels = {}, log) {
  // all labels, from Drupal
  const labels = useComponentLabels();

  // debug
  // eslint-disable-next-line no-console
  if (log) console.log(labels);

  // filter data by component name, and by language
  const getData = l =>
    labels.find(
      item =>
        item.node.name.trim().toLowerCase() === name && item.node.langcode === l
    );

  // get data for current language, otherwise get en-us data
  // @todo: use fallback hierarchy from languages.js helper
  const data = getData(i18n.language) || getData('en');

  // if there is no data for current language, or for en-us, use provided fallbacks
  if (!data) return baseLabels;

  // map data to a usable object (ex: { 'labelButtonClose': 'Close', ... })
  let structuredData = {};
  const handleChildObject = (item, data) => {
    const child = item.description?.processed
      .trim()
      .replace(/(<([^>]+)>)/gi, '');
    const value = item.name;
    // if item is a child, add to structured data
    if (child) {
      data[child] = value;
    }
    // if item is a parent, process again
    else {
      data[value.toLowerCase()] = {};
      processParentObject(item, data[value.toLowerCase()]);
    }
  };
  const processParentObject = (node, data) => {
    node.relationships.taxonomy_term__component_labels.forEach(item =>
      handleChildObject(item, data)
    );
  };
  processParentObject(data.node, structuredData);

  // return fallbacks + structured data
  return { ...baseLabels, ...structuredData };
}
